import { appendProtocol } from '@/postContentElement/components/utils/link';
import { usePostContentContext } from '@/postContentElement/context';
import { evaluateAndAppendUTMParams } from '@/utils/evaluateAndAppendUTMParams';

interface Props {
  anchorId?: string;
  tweetContent?: string;
  tweetUrl?: string;
  profileName?: string;
  profileUsername?: string;
  postedAt?: string;
}

const Twitter = ({ anchorId, tweetContent, tweetUrl, profileName, profileUsername, postedAt }: Props) => {
  const { utmParams } = usePostContentContext();
  const tweetUrlWithUTMParams = evaluateAndAppendUTMParams(appendProtocol(tweetUrl), utmParams);

  return (
    <div className="py-2">
      <div className="twitter-wrapper mx-auto max-w-[520px]" id={anchorId}>
        <blockquote className="twitter-tweet text-center">
          {tweetContent && <p dangerouslySetInnerHTML={{ __html: tweetContent }} />}
          <a href={tweetUrlWithUTMParams}>
            <p>
              &mdash; #{profileName} (#{profileUsername})
              <br />
              {postedAt}
            </p>
          </a>
        </blockquote>
      </div>
    </div>
  );
};

export { Twitter };
